module.exports = __webpack_public_path__ + "assets/img/bp_d_i_7.cbd2de89.jpg";